import UserAvatarContainer from './Container';
import UserAvatarRoot from './Root';

const UserAvatar = {
  Root: UserAvatarRoot,
  Container: UserAvatarContainer,
};

export default UserAvatar;
